import LyPowerButton from './src/index.vue'

LyPowerButton.install = function (Vue) {
    Vue.component(LyPowerButton.name, LyPowerButton)
}

export default LyPowerButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/power-button/index.js
// module id = null
// module chunks = 